import {googleRecaptchaId} from "../../app/read_rp_environment_variables";

export const loadRecaptchaScript = (id: string, callback: () => void) => {
    const isScriptExist = document.getElementById(id);

    if (!isScriptExist) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://www.google.com/recaptcha/api.js?render=${googleRecaptchaId}`;
        script.id = id;
        script.onload = function () {
            if (callback) {
                callback();
            }
        };
        document.body.appendChild(script);
    }

    if (isScriptExist && callback) {
        callback();
    }
};
